export default async function postLoginRedirect({
  route,
  redirect,
  localePath,
  app,
  store,
}) {
  const linkedAccountsResult = await store.dispatch(
    'deduplication/getHasLinkedAccounts'
  )

  if (linkedAccountsResult) {
    return redirect('/settings/account/select-primary-1')
  }

  const duplicatesResult = await store.dispatch(
    'deduplication/getHasDuplicateAccounts'
  )

  if (duplicatesResult) {
    return redirect('/settings/account/multiple_accounts_start_wo_email')
  }

  // Both checks failed, redirect to financials
  return redirect('/financials')
}
